import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyIconSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6732 16.4786H1.54727C1.39172 16.4786 1.23616 16.4268 1.0806 16.2712C0.976901 16.1675 0.925049 16.012 0.925049 15.8564V4.13785C0.925049 3.98229 0.976901 3.82674 1.13246 3.67118C1.23616 3.56748 1.39172 3.51562 1.54727 3.51562H8.02878L11.2436 6.73045V15.8046C11.2436 15.9601 11.1918 16.1157 11.0362 16.2712C10.9843 16.4268 10.8288 16.4786 10.6732 16.4786Z",
			stroke: "currentColor",
			strokeWidth: 1.8503,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.52075 3.51838V1.54801C3.52075 1.39245 3.5726 1.23689 3.72816 1.08134C3.83186 0.977633 3.98742 0.925781 4.14298 0.925781H10.6245L13.8912 4.14061V13.2147C13.8912 13.3703 13.8393 13.5258 13.6838 13.6814C13.5801 13.7851 13.3726 13.8888 13.2171 13.8888H11.2986",
			stroke: "currentColor",
			strokeWidth: 1.8503,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.14282 10.6719H8.03173",
			stroke: "currentColor",
			strokeWidth: 1.8503,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.14282 13.2656H8.03173",
			stroke: "currentColor",
			strokeWidth: 1.8503,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCopyIconSolid;
